import * as React from 'react';

import CreditModel from 'src/model/credit.model';

import './CreditsTableDesktop.scss';
import CreditsRowDesktop from '../CreditsRowDesktop';
import EmptyCredits from '../EmptyCredits';
import CreditsPaymentDetailDesktop from '../CreditsPaymentDetailDesktop';
import CreditsVoidModal from '../CreditsVoidModal';
import { enableScroll, disableScroll } from 'src/utils/documentInteraction';

interface ICreditsTableDesktopProps {
  credits: CreditModel[];
  handleSortedVal(sortVal: string): void;
  desc: string;
  asc: string;
  sortColname: string;
}

interface ICreditsTableDesktopState {
  showCreditDetails: boolean;
  selectedCredit: CreditModel;
  paymentIdToVoid: number;
  showVoidModal: boolean;
}

class CreditsTableDesktop extends React.Component<
  ICreditsTableDesktopProps,
  ICreditsTableDesktopState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      showCreditDetails: false,
      selectedCredit: null,
      paymentIdToVoid: null,
      showVoidModal: false
    };
  }

  private handleCloseModal = () => {
    enableScroll();
    this.setState({
      showCreditDetails: false
    });
  };

  private handleCreditDetails = (e: any, credit: any) => {
    e.preventDefault();
    disableScroll();
    this.setState({
      selectedCredit: credit,
      showCreditDetails: true
    });
  };

  private voidCredit = (paymentId: number) => {
    this.setState({ paymentIdToVoid: paymentId, showVoidModal: true });
  };

  private handleCloseVoidModal = () => {
    this.setState({ showVoidModal: false });
  };

  private handleChangeCheckbox = (credit: any) => {
    if (!credit.taker) {
      this.voidCredit(credit.id);
    }
  };

  public setOrderColumn = (colname: any) => {
    this.props.handleSortedVal(colname);
  };

  public render() {
    return (
      <div className="rp-credits-table-desktop">
        {this.props.credits.length === 0 ? (
          <EmptyCredits />
        ) : (
          <React.Fragment>
            <div className="row rp-credits-table-header">
              <div className="col-3 rp-credits-table-desktop-col">
                <h4>Payment id</h4>
              </div>
              <div
                className={`col-2 rp-credits-table-desktop-col sortable ${
                  this.props.sortColname === 'user.clientIdentity'
                    ? 'selected'
                    : ''
                }`}
                onClick={() => {
                  this.setOrderColumn('user.clientIdentity');
                }}
              >
                <p className="title">Cust code</p>
                <div className="table-header-order">
                  <i className={`rpds-arrow-drop-up ${this.props.asc}`} />
                  <i className={`rpds-arrow-drop-down ${this.props.desc}`} />
                </div>
              </div>
              <div
                className={`col-2 rp-credits-table-desktop-col sortable ${
                  this.props.sortColname === 'pmtDate' ? 'selected' : ''
                }`}
                onClick={() => {
                  this.setOrderColumn('pmtDate');
                }}
              >
                {/* <h4>Pmt time</h4> */}
                <p className="title">Pmt time</p>
                <div className="table-header-order">
                  <i className={`rpds-arrow-drop-up ${this.props.asc}`} />
                  <i className={`rpds-arrow-drop-down ${this.props.desc}`} />
                </div>
              </div>
              <div className="col-2 rp-credits-table-desktop-col">
                <h4>Signature</h4>
              </div>
              <div className="col-3 rp-credits-table-desktop-col">
                <h4>Actions</h4>
              </div>
            </div>
            {this.props.credits.map(credit => (
              <CreditsRowDesktop
                key={credit.paymentId}
                credit={credit}
                onShowDetails={this.handleCreditDetails}
                onChangeCheckbox={this.handleChangeCheckbox}
              />
            ))}
            {this.state.showCreditDetails && this.state.selectedCredit && (
              <CreditsPaymentDetailDesktop
                onCloseModal={this.handleCloseModal}
                creditDetails={this.state.selectedCredit}
              />
            )}
            {this.state.showVoidModal && this.state.paymentIdToVoid && (
              <CreditsVoidModal
                handleCloseModal={this.handleCloseVoidModal}
                paymentId={this.state.paymentIdToVoid}
              />
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default CreditsTableDesktop;
